<style lang="less" scoped>
div.login_bg {height: auto;min-width: 1200px;position: relative;overflow: hidden;}
div.login_bg .login-bg-img {max-width: initial;position: relative;top: 0;left: 50%;-webkit-transform: translateX(-50%);transform: translateX(-50%);}
div.login_bg .layout {width: 1200px;margin: 0px auto;position: absolute;top: 10px;left: 0;right: 0;}
div.login_bg .form_win {background: rgba(255, 255, 255, 0.74);border: 2px solid rgba(204, 204, 204, 0.75);top: 60px;padding-bottom: 80px;}
div.login_bg .form_win .login_btn {font-weight: 700;}
div.login_bg .form_win .tabs {display: -webkit-box;display: -ms-flexbox;display: flex;height: 59px;line-height: 59px;margin-bottom: 20px;border-bottom: solid 1px #c8cbce;}
div.login_bg .form_win .tabs .tab-item {-webkit-box-flex: 1;-ms-flex: 1;flex: 1;text-align: center;font-size: 18px;border-right: solid 1px #c8cbce;cursor: pointer;}
div.login_bg .form_win .tabs .tab-item:last-child {border-right: none;}
div.login_bg .form_win .tabs .tab-item.active {color: #0090ff;background: 0 0;}
div.login_bg .form_win .win_content {width: auto;padding-top: 0;}
div.login_bg .form_win .form-wrap {display: none;background: 0 0;}
div.login_bg .form_win .form-wrap.active, div.login_bg .form_win .form.active {display: block;}
div.login_bg .form_win .form {width: 350px;margin: 0 auto;background: 0 0;}
.hide {display: none;}
.yanzhenginput {width: 220px;text-indent: 10px;margin-top: 8px;border: 1px solid #d5d5d5;height: 40px;}
.yanzhengmabtn {width: 120px;height: 40px;text-align: center;background: #f5f5f5;border: 1px solid #d5d5d5;font-size: 14px;}
.win_input {height: 40px;width: 100%;margin-top: 8px;}
.login_btn {display: block;width: 350px;height: 35px;text-align: center;background: #0090ff;border: none;color: #FFFFFF;margin: 0px auto;margin-top: 10px;border-radius: 3px;}
.tip_p {width: 350px;margin: 5px auto;color: #000;font-size: 14px;display: inline-block;}
.tip_r {display: inline-block;color: #333;margin: 0px;padding: 0px;}
/deep/.win_input.el-input {width: 350px;}
.fl{ float: left;}
.fr{ float: right;}
.type{text-align: left;}
/deep/.phone.el-input {width: 206px;}
.el-form-item {margin-bottom: 10px;}
.validation {width: 140px;}
</style>

<template>
  <div class="form-wrap active">
    <el-form class="register-form form" ref="form" :model="form" :rules="rules">
      <el-form-item class="type">
        注册类型：
        <el-radio-group v-model="form.groupid">
          <el-radio :label="5">个人</el-radio>
          <el-radio :label="6">企业</el-radio>
          <el-radio :label="8">专家</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="username">
        <el-input v-model="form.username" placeholder="请输入您的手机号" class="win_input username"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model="form.password" placeholder="请输入6-16位大小写字母和数字组合" class="win_input" type="password"></el-input>
      </el-form-item>
      <el-form-item prop="password2">
        <el-input v-model="form.password2" placeholder="请再次输入密码" class="win_input" type="password"></el-input>
      </el-form-item>
      <el-form-item prop="">
        <el-input  placeholder="请输入验证码" v-model="form.code" class="win_input phone"></el-input>
        <el-button type="primary" :disabled="flag" class="validation" @click="obtaining()">{{ msg }}</el-button>
      </el-form-item>
      <p class="tip_p" v-if="isShow">验证码5分钟之内有效,请注意查收</p>
      <el-form-item>
        <el-button type="primary" class="login_btn" @click="submitform(form)">同意条款并注册</el-button>
      </el-form-item>
      <p class="tip_r" id="p_tips">注册条款</p>
    </el-form>
  </div>
</template>

<script>
export default {
  data()
  {
    let validatePhone = (rule, value, callback) =>
    {
      let regtel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (value)
      {
        if (!regtel.test(value))
          callback(new Error('请输入正确的手机号'))
        else
          callback()
      }
      else
        callback(new Error('请输入手机号'))
    }
    let validateConfirmPass = (rule, value, callback) =>
    {
      let regtel = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{6,16}$/
      if (value)
      {
        if (!regtel.test(value))
          callback(new Error('密码为6-16位大小写字母和数字组合，请重新输入'))
        else
          callback()
      }
      else
        callback(new Error('请输入密码'))
    }
    let validateConfirmPass2 = (rule, value, callback) =>
    {
      if (value)
      {
        if (value !== this.form.password)
          callback(new Error('两次输入密码不一致!'))
        else
          callback()
      }
      else
        callback(new Error('请输入确认密码'))
    }
    return {
      input1: '',
      form: {
        groupid: 5,
        username: '',
        password: '',
        password2: '',
        code: ''
      },
      username: '',
      msg: '获取验证码',
      flag: false,
      isShow: false,
      rules: {
        username: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        password: [
          { validator: validateConfirmPass, trigger: 'blur' }
        ],
        password2: [
          { validator: validateConfirmPass2, trigger: 'blur' }
        ]
      }
    }
  },
  created()
  {
  },
  methods: {
    //同意注册
    submitform(form)
    {
      if (this.form.username !== '' && this.form.password !== '' && this.form.password2 !== '' && this.form.code !== '')
      {
        this.$refs.form.validate(valid =>
        {
          if (valid)
          {
            let obj = {
              cmd: 'register',
              _major: 11,
              _minor: 28,
              retAtt: 1,
              phone: this.form.username,
              vrycode: this.form.code,
              groupid: this.form.groupid,
              username: this.form.username,
              no: this.form.username,
              password: this.form.password,
              mobile: this.form.username,
              regtime: (Date.parse(new Date()) / 1000)
            }
            window.post.getLoginSvr(obj).then((ret) =>
            {
              if (ret.ret === 0)
              {
                this.$message({message: '注册成功', type: 'success', customClass: 'mzindex'})
                this.$parent.goTheLogin()
              }
              else if (ret.errcode === 'Verification code expired')
                this.$message({message: '验证码已失效，请重新获取', type: 'error', customClass: 'mzindex'})
              else if (ret.errcode === 'User already exists')
                this.$message({message: '该用户已存在', type: 'error', customClass: 'mzindex'})
              else if (ret.errcode === 'errSameTel')
                this.$message({message: '该手机已被注册', type: 'error', customClass: 'mzindex'})
              else if (ret.errcode === 'Validation failed')
                this.$message({message: '该手机已被注册', type: 'error', customClass: 'mzindex'})
            })
          }
          else
            this.$message({message: '请检查您的密码输入规则是否正确', type: 'error', customClass: 'mzindex'})
        })
      }
      else
      {
        if (!this.form.username)
          this.$message({message: '请输入您的手机号', type: 'error', customClass: 'mzindex'})
        else if (!this.form.password)
          this.$message({message: '请输入密码', type: 'error', customClass: 'mzindex'})
        else if (!this.form.password2)
          this.$message({message: '请输入确认密码', type: 'error', customClass: 'mzindex'})
        else if (!this.form.code)
          this.$message({message: '请输入验证码', type: 'error', customClass: 'mzindex'})
      }
    },
    //获取验证码前的判断
    obtaining()
    {
      let regtel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (regtel.test(this.form.username))
      {
        let paras = {
          cmd: 'query',
          _major: 11,
          _minor: 28,
          _exp: `username = '${this.form.username}'`
        }
        window.post.getPost(paras).then((ret) =>
        {
          if (ret.length !== 1)
            this.sendCode()
          else
            this.$message({message: '该手机号已注册', type: 'warning', customClass: 'mzindex'})
        })
      }
      else
        this.$message({message: '请输入正确手机号后再获取验证码', type: 'error', customClass: 'mzindex'})
    },
    //发送短信
    sendCode()
    {
      let obj = {
        cmd: 'sendCode2',
        retAtt: 1,
        phone: this.form.username,
        keyno: 'register'
      }
      window.post.getLoginSvr(obj).then(ret =>
      {
        if (ret.ret === 0)
        {
          this.$message({message: '短信已发送至您的手机，请在验证码有效期使用', type: 'success', customClass: 'mzindex'})
          //获取验证码按钮倒计时功能的实现
          const _this = this
          this.flag = true//按钮不可重复点击
          _this.isShow = true//显示提示文字
          var time = 60//定义时间变量 60s
          var timer = null//定义定时器
          timer = setInterval(function()
          {
            if (time === 0)
            {
              _this.msg = '重新获取验证码'
              _this.flag = false
              _this.isShow = false
              clearInterval(timer)//清除定时器
            }
            else
            {
              _this.msg = time + '秒后重新获取'
              time--
            }
          }, 1000)
        }
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/Registered.vue